import { Layout } from '../Layout';
import * as React from 'react';
import { ErrorAlert } from '../ErrorAlert';
import './LayoutContent.scss';

interface LayoutContentProps {
  className?: string;
  children: any;
  error: Error | null;
}

export const LayoutContent: React.FC<LayoutContentProps> = ({ children, className, error }) => {
  return (
    <Layout.Content className={className}>
      <ErrorAlert error={error} />
      {children}
    </Layout.Content>
  );
};
